import React from 'react';
import * as ds from './dataService';
import {
  FormBaseLayout,
  SelectPrecipitationTypeField,
  SelectWeatherConditionField,
  StyledTextField
} from 'modules';
import _ from 'lodash';

export type SaveWeatherFormProps = {
  id: string;
  dailyReportId?: string;
  handleClose: () => void;
};

export const FC = (props: SaveWeatherFormProps) => {
  const [
    fnSaveWeatherForm,
    { loading }
  ] = ds.useSaveWeather();
  const form = ds.useFormState(props.id, props.dailyReportId ?? '');
  const handleSubmit = async (data: ds.IFormState) => {
    await fnSaveWeatherForm({
      id: data.id ?? undefined,
      conditionId: data.conditionId,
      precipitationTypeId: data.precipitationTypeId,
      temperatureMax: data.temperatureMax,
      temperatureMin: data.temperatureMin,
      precipitationAmount: data.precipitationAmount
    });
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <SelectWeatherConditionField.FC
        form={form}
        fieldName='conditionId'
      />
      <SelectPrecipitationTypeField.FC
        form={form}
        fieldName='precipitationTypeId'
      />
      <StyledTextField.FC
        {...form.genFieldProps('temperatureMin')}
        value={form.formState.temperatureMin.toString()}
        onChange={(e) => form.dispatch({
          type: 'UPDATE',
          payload: {
            property: 'temperatureMin',
            value:
              _.toNumber(`${e.target.value}`)

          }
        })}
      />
      <StyledTextField.FC
        {...form.genFieldProps('precipitationAmount')}
        value={form.formState.precipitationAmount.toString()}
        onChange={(e) => form.dispatch({
          type: 'UPDATE',
          payload: {
            property: 'precipitationAmount',
            value:
              _.toNumber(`${e.target.value}`)

          }
        })}
      />
    </FormBaseLayout.FC>

  );
};
